import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import Toggle from 'react-toggle'
import 'react-toggle/style.css' // Import the styles

const TaskDetail = () => {
  const { id } = useParams();
  const [isTaskPushed, setIsTaskPushed] = useState(false);
  const [isTaskCompleted, setIsTaskCompleted] = useState(false);

  // Use state to track tasks
  const [tasks, setTasks] = useState([
    { priority: 1, name: 'R&D', isCompleted: false },
    { priority: 2, name: 'Design', isCompleted: false },
    { priority: 3, name: 'Creative', isCompleted: false },
    { priority: 4, name: 'Content', isCompleted: false },
    { priority: 5, name: '3d Design', isCompleted: false },
    { priority: 6, name: 'Tile Repetition', isCompleted: false },
    { priority: 7, name: 'Without Brand', isCompleted: false },
  ])

  // Handle task completion toggle
  const handleTaskCompletionChange = (index) => {
    const updatedTasks = tasks.map((task, i) =>
      i === index ? { ...task, isCompleted: !task.isCompleted } : task,
    )
    setTasks(updatedTasks)

    console.log(
      `Task ${index + 1} completion status changed to: ${updatedTasks[index].isCompleted}`,
    )
  }

  return (
    <div className='max-w-3xl mx-auto p-4 sm:p-6'>
      <div className='space-y-6'>
        {/* Header */}
        <div className="space-y-4">
          <h1 className="text-xl sm:text-2xl font-semibold text-gray-900">
            Task Detail (ID: {id})
          </h1>
          <h2 className='text-lg sm:text-xl font-semibold text-gray-700'>
            Tiles Company #CATALOG 800X1600
          </h2>
          <div className='flex flex-col sm:flex-row items-start sm:items-center gap-4'>
            <label className='flex items-center space-x-2'>
              <Toggle
                checked={isTaskPushed}
                onChange={() => setIsTaskPushed(!isTaskPushed)}
                icons={false}
              />
              <span className='text-sm sm:text-base text-gray-700'>
                TASK PUSH ?
              </span>
            </label>
            <label className='flex items-center space-x-2'>
              <input
                type='checkbox'
                checked={isTaskCompleted}
                onChange={() => setIsTaskCompleted(!isTaskCompleted)}
                className='h-4 w-4 sm:h-5 sm:w-5 appearance-none border border-gray-300 rounded bg-white checked:bg-orange-500 checked:border-orange-500 relative focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2'
              />
              <span className='text-sm sm:text-base text-gray-700'>
                TASK COMPLETED ?
              </span>
            </label>
          </div>
        </div>

        {/* Tasks List */}
        <div className='space-y-4'>
          {tasks.map((task, index) => (
            <div key={task.priority} className='border-b border-gray-200 pb-4'>
              <div className='text-sm sm:text-base text-gray-900 mb-2'>
                ( Priority = {task.priority} ) {task.name}
              </div>
              <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4'>
                <div className='flex items-center gap-2 sm:gap-4'>
                  <span className='text-xs sm:text-sm text-gray-600'>
                    IS RUNNING ?
                  </span>
                  <div className='flex items-center gap-1 sm:gap-2'>
                    <div className='w-2 h-2 rounded-full bg-green-500'></div>
                    <span className='text-xs sm:text-sm text-gray-600'>
                      21 Jul 2024
                    </span>
                  </div>
                </div>
                <label className='flex items-center space-x-2'>
                  <input
                    type='checkbox'
                    checked={task.isCompleted}
                    onChange={() => handleTaskCompletionChange(index)}
                    className='h-4 w-4 sm:h-5 sm:w-5 appearance-none border border-gray-300 rounded bg-white checked:bg-orange-500 checked:border-orange-500 relative focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2'
                  />
                  <span className='text-xs sm:text-sm text-gray-700'>
                    IS COMPLETED ?
                  </span>
                  <style jsx>{`
                    input[type='checkbox']:checked::after {
                      content: '✓';
                      font-size: 12px;
                      color: white;
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                    }
                  `}</style>
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TaskDetail
